import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'kp-detail-view-action',
  templateUrl: './detail-view-action.component.html',
  styleUrls: ['./detail-view-action.component.scss'],
})
export class DetailViewActionComponent {
  @Input() infoText: string;
  @Input() primaryIconUrl: string;
  @Input() saveDisabled = false;
  @Input() showEditableAction = false;
  @Input() showCompactAction = false;
  @Input() showInfo = false;
  @Input() title: string;

  @Output() primaryIconClicked = new EventEmitter<void>();
  @Output() saveClicked = new EventEmitter<void>();
  @Output() trashIconClicked = new EventEmitter<void>();

  expandInfo() {
    this.showInfo = !this.showInfo;
  }
}
